<template>
    <div id="reason_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="reasonHeader" v-if="$route.params.id > 0">Update Damage Code</span>
                    <span class="page-title" id="reasonHeader" v-else>Add Damage Code</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackReasonList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container metric-form" id="ReasonForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                      <label class="control-label require" for="code">Code:</label>
                                      <input type="text" class="form-control" v-model="code" id="code"
                                             placeholder="Enter Code" name="code" :disabled="disableFormFields">
                                      <div class="field-error">{{ code_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                      <label class="control-label require" for="name">Name:</label>
                                      <input type="text" class="form-control" v-model="name" id="name"
                                             placeholder="Enter Name" name="name" :disabled="disableFormFields">
                                      <div class="field-error">{{ name_error_msg }}</div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                              <div class="btn-groups">
                                <button type="submit" id="createReasonBtn" v-if="$route.params.id > 0"
                                        class="btn btn-primary" v-on:click.prevent="CreateReason"
                                        :disabled="disableFormFields">
                                  <i class="fp-reload"> </i> Update
                                </button>
                                <button type="submit" id="createReasonBtn" v-else class="btn btn-primary"
                                        v-on:click.prevent="CreateReason" :disabled="disableFormFields">
                                  <i class="fp-save"> </i> Save
                                </button>
                                <!--                                    <button type="submit" id="createAndContinueReasonBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateReason(flag='Save and Continue')" >-->
                                <!--                                    <i class="fp-save-continue"> </i>  Save and Continue-->
                                <!--                                    </button>-->
                                <button type="submit" id="cancelReasonBtn" class="btn btn-tertiary"
                                        v-on:click.prevent="BackReasonList">
                                  <i class="fp-close"> </i> Cancel
                                </button>
                              </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';


export default {
  name: "ReasonCreate",

  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Damage Code | " +process.env.COPYRIGHT_NAME : "Create Damage Code | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    code: "",
    name: "",
    loading:false,
    code_error_msg: "",
    name_error_msg: "",
    disableFormFields: false,
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name === 'add_damage_code') {
                        self.cantAccessPage = true;
                    }
                }
            }

        }
   },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();

        setTimeout(function () {
            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[3]) {
                self.loadReason();
            }
        }, 100);
  },
  methods: {
    BackReasonList() {
      var self = this;
      self.$router.push("/damage-code/list");
    },

    CreateReason(flag) {
      var self = this;

      self.code = self.code.trim();
      self.name = self.name.trim();

      self.code_error_msg = "";
      self.name_error_msg = "";


      if (!self.code || self.code == null || self.code == "") {
        self.code_error_msg = "Code Required.";
      }

      if (!self.name || self.name == null || self.name == "") {
        self.name_error_msg = "Name Required.";
      }

      if (self.code_error_msg == "" && self.name_error_msg == "") {
            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createReasonBtn").val("Updating ...");
                $("#createReasonBtn").prop("disabled", true);
                $("#cancelReasonBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueReasonBtn").val("Saving ...");
                    $("#createReasonBtn").prop("disabled", true);
                    $("#createAndContinueReasonBtn").prop("disabled", true);
                    $("#cancelReasonBtn").prop("disabled",true);

                }else{

                    $("#createReasonBtn").val("Saving ...");
                    $("#createReasonBtn").prop("disabled", true);
                    $("#createAndContinueReasonBtn").prop("disabled", true);
                    $("#cancelReasonBtn").prop("disabled",true);
                }

            }

            $.ajax({
                url: process.env.ROOT_API + "/reason/create",
                type: "POST",
                data: {code: self.code, name: self.name,id: segments[3]},
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createReasonBtn").val("Update");
                        $("#createReasonBtn").prop("disabled", false);
                        $("#cancelReasonBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueReasonBtn").val("Save and Continue");
                            $("#createReasonBtn").prop("disabled", false);
                            $("#createAndContinueReasonBtn").prop("disabled", false);
                            $("#cancelReasonBtn").prop("disabled",false);

                        }else{

                            $("#createReasonBtn").val("Save");
                            $("#createReasonBtn").prop("disabled", false);
                            $("#createAndContinueReasonBtn").prop("disabled", false);
                            $("#cancelReasonBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            $("#ReasonForm").trigger("reset");
                            self.code = "";
                            self.name ="";

                        }else{
                            self.$router.push("/damage-code/list");
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createReasonBtn").val("Update");
                        $("#createReasonBtn").prop("disabled", false);
                        $("#cancelReasonBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#ReasonForm").trigger("reset");


                            $("#createAndContinueReasonBtn").val("Save and Continue");
                            $("#createReasonBtn").prop("disabled", false);
                            $("#createAndContinueReasonBtn").prop("disabled", false);
                            $("#cancelReasonBtn").prop("disabled",false);

                        }else{

                            $("#createReasonBtn").val("Save");
                            $("#createReasonBtn").prop("disabled", false);
                            $("#createAndContinueReasonBtn").prop("disabled", false);
                            $("#cancelReasonBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'reason-create')
                }
            });
      }else{
          self.errorValidationFocus();
      }

    },

    loadReason() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/reason/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {
                    self.code = data.content.code;
                    self.name = data.content.name;
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'reason-by-id');
                self.disableFormFields = true;
            }
        });
    },

  }
};
</script>



// WEBPACK FOOTER //
// src/components/ReasonCreate.vue